import { COMMON_COMPONENT_TYPES, COMMON_COMPONENT_NAMES } from "constants/flowDesigner";
import { ThemedMailIcon } from "assets/CXFIcons/Static";
import { ThemedServerIcon } from "assets/CXFIcons/Triggers";
import {
   ThemedCodeIcon,
   ThemedCodeBranch,
   ThemedArrowSplitIcon,
   ThemedDatabaseIcon,
   ThemedFileArrowDown,
   ThemedArrowTurnDownRight,
   ThemedArrowTurnUpRight,
   ThemedArrowRightArrowLeft,
   ThemedFileCode,
   ThemedHourglass
} from "assets/CXFIcons/Designer/CommonComponentNodes";
import { ThemedFlagIcon } from "assets/CXFIcons/Static";
import { ThemedWebhookIcon } from "assets/CXFIcons/Triggers";

const commonComponents = [
   {
      type: COMMON_COMPONENT_TYPES.MCP_CLIENT,
      label: COMMON_COMPONENT_NAMES.MCP_CLIENT,
      icon: ThemedServerIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.CONDITIONAL,
      label: COMMON_COMPONENT_NAMES.CONDITIONAL,
      icon: ThemedArrowSplitIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.SELECTION,
      label: COMMON_COMPONENT_NAMES.SELECTION,
      icon: ThemedCodeBranch
   },
   {
      type: COMMON_COMPONENT_TYPES.VARIABLES,
      label: COMMON_COMPONENT_NAMES.VARIABLES,
      icon: ThemedFileCode
   },
   {
      type: COMMON_COMPONENT_TYPES.REST_API,
      label: COMMON_COMPONENT_NAMES.REST_API,
      icon: ThemedArrowRightArrowLeft
   },
   {
      type: COMMON_COMPONENT_TYPES.WEBHOOK,
      label: COMMON_COMPONENT_NAMES.WEBHOOK,
      icon: ThemedWebhookIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.EMAIL,
      label: COMMON_COMPONENT_NAMES.EMAIL,
      icon: ThemedMailIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.DATABASE,
      label: COMMON_COMPONENT_NAMES.DATABASE,
      icon: ThemedDatabaseIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.SFTP,
      label: COMMON_COMPONENT_NAMES.SFTP,
      icon: ThemedFileArrowDown
   },
   {
      type: COMMON_COMPONENT_TYPES.GOTO,
      label: COMMON_COMPONENT_NAMES.GOTO,
      icon: ThemedArrowTurnDownRight
   },
   {
      type: COMMON_COMPONENT_TYPES.DELAY,
      label: COMMON_COMPONENT_NAMES.DELAY,
      icon: ThemedHourglass
   },
   {
      type: COMMON_COMPONENT_TYPES.CODE,
      label: COMMON_COMPONENT_NAMES.CODE,
      icon: ThemedCodeIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.REDIS,
      label: COMMON_COMPONENT_NAMES.REDIS,
      icon: ThemedServerIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.DATA_LOGGER,
      label: COMMON_COMPONENT_NAMES.DATA_LOGGER,
      icon: ThemedServerIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.INVOKE,
      label: COMMON_COMPONENT_NAMES.INVOKE,
      icon: ThemedArrowTurnDownRight
   },
   {
      type: COMMON_COMPONENT_TYPES.SESSION_STORAGE,
      label: COMMON_COMPONENT_NAMES.SESSION_STORAGE,
      icon: ThemedServerIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.END,
      label: COMMON_COMPONENT_NAMES.END,
      icon: ThemedFlagIcon
   },
   {
      type: COMMON_COMPONENT_TYPES.RESPOND,
      label: COMMON_COMPONENT_NAMES.RESPOND,
      icon: ThemedArrowTurnUpRight
   }
];

export default commonComponents;
